import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const SidebarContainer = styled(Box)(({ isCollapsed, theme }) => ({
  boxShadow: '0px 5px 4px 6px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  flexDirection: 'column',
  width: isCollapsed ? '70px' : '260px',
  transition: 'width 0.3s ease',
  backgroundColor: theme.palette.jigsaw.white,
  zIndex: 10,
  position: "relative",
  height: '100vh',
}));

export const TopSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingTop: theme.spacing(4),
  paddingLeft: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  position: 'relative',
}));

export const LinkList = styled('ul')({
  listStyleType: 'none',
  padding: 2,
  margin: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  alignSelf: 'center',
});

export const Logo = styled('div')(({ isCollapsed }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '20px',
  position: 'relative',
  width: '100%',
  height: '100%', 
  visibility: isCollapsed ? 'hidden' : 'visible',

  img: {
    width: '152px',
    height: '42px',
    padding: '0px 29px 0px 30px',
    gap: '11.82px'
  },
}));


export const CollapseButton = styled('button')({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '5px',
  position: 'absolute',
  justifyContent: 'center',
  top: '35px',
  right: '20px',

  img: {
    width: '24px',
    height: '24px',
  },
});

export const ActiveIndicator = styled(Box)(({ theme }) => ({
  borderRadius: '0 2px 2px 0',
  color: theme.palette.jigsaw.green,
  backgroundColor: theme.palette.jigsaw.green,
  width: '5px',
  height: '20px',
  margin: 'auto 0',
  alignSelf: 'flex-start',
}));

export const LinkItem = styled('li')(({ isActive, theme }) => ({
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(1, 2.5, 1, 0),
  justifyContent: 'flex-start',

  '& a': {
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },

  ...(isActive && {
    backgroundColor: `${theme.palette.background.paper}`,
    boxShadow: 'inset 0px 6px 12px rgba(200, 200, 200, 0.8)',
    '& span': {
      color: theme.palette.jigsaw.green,
    },
  }),
}));

export const LinkIcon = styled('img')(({ isActive, theme }) => ({
  aspectRatio: 1,
  objectFit: 'contain',
  objectPosition: 'center',
  width: '24px',
  alignSelf: 'center',
  marginLeft: '10px',
  ...(isActive && {
    '& path': {
      fill: theme.palette.jigsaw.green,
    },
  }),
}));

export const LogoutButton = styled('button')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  background: 'transparent',
  color: '#f44336',
  border: '1px solid #f44336',
  borderRadius: '4px',
  padding: '8px 12px',
  marginBottom: '12px',
  marginLeft: '15px',
  marginRight: '12px',
  cursor: 'pointer',
  fontSize: '14px',
  transition: 'all 0.2s ease',
  width: '80%',
  justifyContent: 'center',
  position: 'absolute',
  bottom: '12px',

  '&:hover': {
    background: '#f44336',
    color: 'white',
  },

  '& svg': {
    fontSize: '18px',
  }
}));